/**
 * Canonical "Columns to be declared" text per Facts panel format for label (business rules).
 * Format values match API/onload option names (same strings used in nutrition form state).
 */

export const NUTRITION_FACTS_NOT_REQUIRED = "Nutrition Facts Not Required";
export const SUPPLEMENT_FACTS_PANEL = "Supplement Facts Panel";

/** Simplified panel for bottled water — single column line only */
export const SIMPLIFIED_NUTRITION_FACTS_PANEL_BOTTLED_WATER =
  "Simplified Nutrition Facts Panel - Bottled Water";

const DUAL_COLUMN_2016 = "2016 Dual Column Nutrition Facts Label";
const DUAL_WITH_SIDES = "Dual Nutrition Facts Panel - with Sides";
const DUAL_AS_PREPARED = "Dual Nutrition Facts Panel - as Prepared";

const DEFAULT_COLUMNS_TO_DECLARE = ["Per Serving", "%Daily Value Per Serving"].join("\n");

const DUAL_COLUMN_COLUMNS_TO_DECLARE = [
  "Per Serving",
  "%Daily Value Per Serving",
  "Per Serving As Prepared",
  "%Reference Intake Per Serving As Prepared",
].join("\n");

export function isNutritionFactsNotRequiredFormat(factsPanelFormat: string): boolean {
  return String(factsPanelFormat ?? "").trim() === NUTRITION_FACTS_NOT_REQUIRED;
}

export function isSupplementFactsPanelFormat(factsPanelFormat: string): boolean {
  return String(factsPanelFormat ?? "").trim() === SUPPLEMENT_FACTS_PANEL;
}

/** Facts panel formats that disable the Nutrition Declaration sub-tab. */
export function blocksNutritionDeclarationTab(factsPanelFormat: string): boolean {
  const format = String(factsPanelFormat ?? "").trim();
  return isNutritionFactsNotRequiredFormat(format) || isSupplementFactsPanelFormat(format);
}

export function isDualColumnFactsPanelFormat(format: string): boolean {
  const f = String(format ?? "").trim();
  return f === DUAL_COLUMN_2016 || f === DUAL_WITH_SIDES || f === DUAL_AS_PREPARED;
}

/**
 * Returns the columns-to-declare body for the selected facts panel format.
 * Empty string when format is empty or "Nutrition Facts Not Required".
 */
export function getColumnsToDeclareTextForFactsPanelFormat(factsPanelFormat: string): string {
  const format = String(factsPanelFormat ?? "").trim();
  if (!format || isNutritionFactsNotRequiredFormat(format)) {
    return "";
  }
  if (format === SIMPLIFIED_NUTRITION_FACTS_PANEL_BOTTLED_WATER) {
    return "Per Serving";
  }
  if (isDualColumnFactsPanelFormat(format)) {
    return DUAL_COLUMN_COLUMNS_TO_DECLARE;
  }
  return DEFAULT_COLUMNS_TO_DECLARE;
}
